<script setup lang="ts">
import { ref } from 'vue';
import apiClient from '@src/api/api-client.js';
import clientIdStore from '@src/application/store/client-identifier-store.js';
import VerticalAlignChildrenWrapper from '@components/layout-wrapper/vertical-align-children-wrapper.vue';
import CenterChildrenWrapper from '@components/layout-wrapper/center-children-wrapper.vue';
import Button from '@components/buttons/button.vue';
import Input from '@components/form/input.vue';
import { closeLoader, openLoader } from '@utils/loader-util.js';
import { createErrorModal } from '@utils/modal-util.js';
import { useSingleRefComposable } from '@src/application/composables/single-ref-composable.ts';

const emit = defineEmits<{
    save: [clientId: string],
    abort: [],
}>();

const clientId = ref<string|null>(clientIdStore.clientId.data);

const { singleRef, setSingleTemplateRef } = useSingleRefComposable<InstanceType<typeof Input>>();

async function save() {
    singleRef.value?.submit();

    if (clientId.value !== null) {
        openLoader();
        const result = (await apiClient.get('/client/check-client-identifier/' + encodeURIComponent(clientId.value))).data;
        closeLoader();
        if (!result.exists) {
            await createErrorModal('Client-ID existiert nicht', 'Es gibt keine Client-ID: "' + clientId.value + '"');
            return;
        }
    }

    clientIdStore.clientId.data = clientId.value;

    emit('save', clientId.value!);
}
</script>

<template>
    <div>
        <Input
            :ref="setSingleTemplateRef"
            v-model="clientId"
            label="Client-ID"
            :required="false"
        />
        <VerticalAlignChildrenWrapper gap-top="3">
            <CenterChildrenWrapper>
                <Button context="primary" @click="save">Speichern</Button>
                <Button @click="emit('abort')">Abbrechen</Button>
            </CenterChildrenWrapper>
        </VerticalAlignChildrenWrapper>
    </div>
</template>
